import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";

export const model = {
  browserClient: String,
  ip: Optional(String),
  isCurrentSession: Boolean,
  operatingSystem: String,
  sessionCreatedAt: Date,
  sessionExpiry: Date,
  sessionTrackerId: String,
} satisfies ModelDefinition;

export type ActiveSession = FromModel<typeof model>;

const ActiveSessionModel = createModel({
  data: {
    activeSession: model,
  },
}).transform(model, (data) => data.data.activeSession);

export default ActiveSessionModel;
